import { render, staticRenderFns } from "./LoanRecoveryModel.vue?vue&type=template&id=28b99553&scoped=true&"
import script from "./LoanRecoveryModel.vue?vue&type=script&lang=js&"
export * from "./LoanRecoveryModel.vue?vue&type=script&lang=js&"
import style0 from "./LoanRecoveryModel.vue?vue&type=style&index=0&id=28b99553&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b99553",
  null
  
)

export default component.exports